import { GenerationPage } from "./GenerationPage";

// Загрузка кастомного шрифта Minecraftia
const fontFace = new FontFace(
  "Minecraftia",
  "url(/models/treasure-hunt/fonts/Minecraftia-Regular.ttf)"
);
fontFace.load().then((loadedFont) => {
  document.fonts.add(loadedFont);
});

export const BattleshipPage = () => {

  return (
    <div className="relative w-screen h-screen">
      <GenerationPage />
    </div>
  );
};
